/**
 * @generated SignedSource<<fb4c6012fe9715dc8972734f4463a41e>>
 * @relayHash ff1c71e83a12c625b5ba62732b828dca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0bff668cb41db1b8358bae2dfd91cbd4a7b2eca1685b90f9f53df59ed24e136a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isJscInlineEditFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-inline-edit-fast-follows-enabled.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';
import isRemoveIssueTypes_provider from '@atlassian/jira-relay-provider/src/remove-issue-types-dfo.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0bff668cb41db1b8358bae2dfd91cbd4a7b2eca1685b90f9f53df59ed24e136a",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcremoveissuetypesdforelayprovider": isRemoveIssueTypes_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider
    }
  }
};

export default node;
